// Re-shade gate for the hair renderer. Pure (no THREE/DOM) so it's
// unit-testable.
//
// Per-frame relighting: the GPU-resident shade (WGSL spec_mod + fused shade) is
// cheap enough to re-shade every frame the view moves, so there is NO time
// throttle by default (MIN_INTERVAL_MS = 0). Pacing is done by BACKPRESSURE
// instead — HairRenderer.update bails while a shade is in flight
// (`_shadeInFlight`: `_busy` OR a dispatched readback not yet applied) — not by a
// wall-clock interval. The shade is strictly serial (1 shade → 1 apply → next,
// no overlap). (Historically this throttled to 1/100ms because the shade was a
// ~500ms CPU pass; that cost is gone.)
//
//   drift ≤ MOVE_EPS   → settled, skip (stops idle re-shading once motion ends)
//   drift > MOVE_EPS   → shade this frame
//
// Because drift is measured from the last-shaded pose and stays above MOVE_EPS
// until the resting pose is actually shaded, this still GUARANTEES a final crisp
// shade of the at-rest view — specular is view-dependent, so it must be correct.
//
// `minIntervalMs` is retained (default 0) so a caller can opt back into a
// wall-clock throttle (e.g. a future reduced-power mode) without new plumbing.

export const HAIR_SHADE_MOVE_EPS = 5e-4;
export const HAIR_SHADE_MIN_INTERVAL_MS = 0;

export function shouldShade({
  drift,
  now,
  lastShadeAt,
  moveEps = HAIR_SHADE_MOVE_EPS,
  minIntervalMs = HAIR_SHADE_MIN_INTERVAL_MS,
}) {
  if (!(drift > moveEps)) return false;
  return now - lastShadeAt >= minIntervalMs;
}
